export enum EMyHomeFrom {
  fromHeader = '?from=header',
  fromMain = '?from=main_menu',
}
